import PropTypes from "prop-types"
import scroll from "scroll"
import scrollDoc from "scroll-doc"

import Button from "components/ui/button"

const OutOfStockBanner = ({ outOfStockRef }) => {
  const scrollToActions = () => {
    if (outOfStockRef?.current) {
      const page = scrollDoc()
      const offset = outOfStockRef.current.offsetTop - 380
      scroll.top(page, offset)
    }
  }

  return (
    <div className="flex justify-center">
      <div className="inline-block rounded-lg bg-black px-10 py-6 text-center">
        <p className="text-14 tracking-tigher leading-16 font-bold text-white">
          Oh no! Temporarily Out of Stock
        </p>
        <Button
          className="text-14 tracking-tigher leading-16 font-bold text-white"
          onClick={scrollToActions}
          text
          underline
        >
          Notify Me!
        </Button>
      </div>
    </div>
  )
}

OutOfStockBanner.propTypes = {
  outOfStockRef: PropTypes.object,
}

export default OutOfStockBanner
